import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.styl';
import icons from '../../assets/comet/comet.svg';

class Accordion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      visited: false
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.open &&
      this.props.closeAllButIndex !== false &&
      prevProps.closeAllButIndex !== this.props.closeAllButIndex &&
      this.props.closeAllButIndex !== this.props.index
    ) {
      this.setState({
        open: false
      });
    }
  }

  accordionClasses = () => {
    const { open, visited } = this.state;
    return classNames(
      {
        'accordion--open': open,
        'accordion--visited': visited
      },
      'accordion'
    );
  };

  accordionTitleClasses = () => {
    const { open, visited } = this.state;
    return classNames(
      {
        'accordion__title--open': open,
        'accordion__title--visited': visited
      },
      'accordion__title'
    );
  };

  toggle = e => {
    e.preventDefault();

    this.setState({
      open: !this.state.open,
      visited: true
    });

    if (this.props.onToggle) {
      this.props.onToggle(!this.state.open, this.props.index);
    }
  };

  determineAccordionIcon = () => {
    const { open, visited } = this.state;
    if (open) {
      return 'caret-up';
    } else if (visited) {
      return 'check';
    } else {
      return 'caret-down';
    }
  };

  render() {
    const { open } = this.state;
    return (
      <div className={this.accordionClasses()}>
        <a
          className={this.accordionTitleClasses()}
          href=""
          onClick={this.toggle}
        >
          <span>{this.props.data.title}</span>
          <svg className="comet-icon--s" aria-hidden="true" focusable="false">
            <use xlinkHref={`${icons}#${this.determineAccordionIcon()}`} />
          </svg>
        </a>
        <div hidden={!open} className="accordion__body">
          {this.props.data.content}
        </div>
      </div>
    );
  }
}

Accordion.defaultProps = {
  closeAllButIndex: false
};

Accordion.propTypes = {
  closeAllButIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([false])
  ]),
  data: PropTypes.shape({
    content: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  index: PropTypes.number,
  onToggle: PropTypes.func
};

export default Accordion;



// WEBPACK FOOTER //
// ../core/src/components/Accordion/Accordion.js